import { Dispatch, MutableRefObject, SetStateAction, useEffect, useState } from 'react'
import {
  IC_CAF_ACCURACY_BLACK,
  IC_CAF_COMPLEXITY_BLACK,
  IC_CAF_FLUENCY_BLACK,
  IC_CAF_OVERALL_FIRE,
  IC_CAF_PRONUNCIATION_BLACK,
  IC_CAF_SYMBOL_BLACK,
} from '../../../../images'

import { HIGHLIGHT_METRIC } from '../../../../../model/caf.interface'

import produce from 'immer'
import { throttle } from 'lodash'
import { n_caf, s_caf } from '../../../../i18n/strings/auto/wording_webview'

interface rollbackChartColorProps {
  data: any
  setData: Dispatch<SetStateAction<any>>
  color?: string
  callback?: (any) => void
}

// 바 차트 외부 터치시 원복
export const useRollbackChartColor = () => {
  return ({ data, setData, color, callback }: rollbackChartColorProps) => {
    if (!callback) {
      setData(
        produce(data, (draft) => {
          draft?.map((item) => (item.color = color))
        })
      )
    } else {
      setData(
        produce(data, (draft) => {
          draft?.map((item) => callback(item))
        })
      )
    }
  }
}

export const axisRange = (stop, size, gap) => Array.from({ length: stop / size + gap }, (_, i) => i * size)

export const maxAxisRange = (data, key) => {
  const maxValue =
    data?.reduce((prev, value) => {
      return prev[key] >= value[key] ? prev : value
    }, []) || []
  return maxValue[key]
}

export const useScrollPosition = (scrollRef: MutableRefObject<HTMLDivElement>) => {
  const [scrollX, setX] = useState(0)

  useEffect(() => {
    const scrolling = scrollRef.current
    const deb = throttle(() => {
      setX(scrolling.scrollLeft)
    }, 100)
    scrolling?.addEventListener('scroll', deb)

    return () => scrolling.removeEventListener('scroll', deb)
  }, [scrollRef])

  return [scrollX, setX]
}

export const CAF_icon_list = {
  overall: IC_CAF_OVERALL_FIRE, // CAF Level
  complexity: IC_CAF_COMPLEXITY_BLACK,
  fluency: IC_CAF_FLUENCY_BLACK,
  accuracy: IC_CAF_ACCURACY_BLACK,
  pronunciation: IC_CAF_PRONUNCIATION_BLACK,
  all: IC_CAF_SYMBOL_BLACK, // CAF 전체
}

export const HEADER_NAV_TAG_WORDING = {
  0: s_caf.accuracy.error_type1,
  1: s_caf.accuracy.error_type2,
  2: s_caf.accuracy.error_type3,
  3: s_caf.accuracy.error_type4,
  4: s_caf.accuracy.error_type5,
  5: s_caf.accuracy.error_type6,
  6: s_caf.accuracy.error_type7,
  7: s_caf.accuracy.error_type8,
  8: s_caf.accuracy.error_type9,
  9: s_caf.accuracy.error_type10,
  10: s_caf.accuracy.error_type11,
  11: s_caf.accuracy.error_type12,
  12: s_caf.accuracy.error_type13,
  13: s_caf.highlight.category13,
  14: s_caf.highlight.category14,
  15: s_caf.highlight.category15,
  16: s_caf.highlight.category16,
  17: s_caf.highlight.category17,
  18: n_caf.highlight.category18,
}

// 값이 1 미만인 경우 소수점 1자리까지 표시하고, 1 이상인 경우 소수점 0자리까지 표시
export const getRoundValue = (value) => {
  if (value < 1) return Math.round(value * 10) / 10
  return isNaN(Math.round(value)) ? 0 : Math.round(value)
}

export const getMetric = (tagId) => {
  switch (+tagId) {
    case 13:
      return HIGHLIGHT_METRIC.REPETITION
    case 14:
      return HIGHLIGHT_METRIC.RUNON
    case 15:
      return HIGHLIGHT_METRIC.SPEECH_RATE
    case 16:
      return HIGHLIGHT_METRIC.FILLER_WORD
    case 17:
      return HIGHLIGHT_METRIC.SENTENCE_STRUCTURE
    case 18:
      return HIGHLIGHT_METRIC.PRONUNCIATION

    default:
      return HIGHLIGHT_METRIC.GRAMMAR
  }
}
